/**
 * Validates email address format
 * Accepts all valid email domains
 */
export const isValidEmail = (email: string): boolean => {
  // Basic email regex that accepts all domains
  // Allows letters, numbers, dots, hyphens, underscores before @
  // Requires at least one dot after @ for domain
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(email)
}

/**
 * More permissive email validation for edge cases
 * Use this if you want to accept more unusual but valid emails
 */
export const isValidEmailPermissive = (email: string): boolean => {
  // Even more permissive - just requires @ and a dot after it
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}